import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {AffiliatePointState, getInitialState} from '@web/slices/affiliatePoint/slice'

import type {AffiliatePointReducers, MakeCreateSliceOptions} from './interfaces'

const makeSlice = (options?: MakeCreateSliceOptions) =>
    createSlice<AffiliatePointState, AffiliatePointReducers, 'affiliatePoint', SliceSelectors<AffiliatePointState>>({
        name: 'affiliatePoint',
        initialState: getInitialState(),
        reducers: {
            transition(state, {payload}) {
                state.scene = payload
            },
        },
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.affiliatePoint ?? state
            })
        },
    })

export default makeSlice
